import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicOverviewDiagramContent } from "./CardiometabolicOverviewDiagram";

const SvgCardiometabolicOverviewDiagramKey = ({
  showKey = true,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1328, 1328)}
      viewBox={diagramOnly ? "0 0 1024 1328" : "0 0 1024 1328"}
    >
      <g id="cardiometabolic-overview-diagram+key" clipPath="url(#clip0_18295_238207)">
        <rect width={1024} height={diagramOnly ? 1328 : 1328} fill="white" />

        <CardiometabolicOverviewDiagramContent />
      </g>
      <defs>
        <clipPath id="clip0_18295_238207">
          <rect width={1024} height={1328} fill="white" />
        </clipPath>
        <clipPath id="clip1_18295_238207">
          <rect width={1024} height={1328} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicOverviewDiagramKey;
